import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/cn';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-1.5 font-semibold whitespace-nowrap border transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-ring',
  {
    variants: {
      variant: {
        primary: 'bg-accent text-accent-ink border-accent hover:bg-accent/90',
        secondary: 'bg-surface text-ink border-line hover:bg-bg',
        ghost: 'bg-transparent text-ink-2 border-transparent hover:bg-bg',
        dark: 'bg-[#1c2940] text-[#e8ecf3] border-[#2a3a55] hover:bg-[#233356]',
        danger: 'bg-surface text-bad border-[#f4cfca] hover:bg-bad-soft',
      },
      size: {
        sm: 'h-7 px-2.5 text-[12px] rounded-[7px]',
        md: 'h-[34px] px-3.5 text-[13px] rounded-lg',
        lg: 'h-10 px-4 text-sm rounded-[9px]',
      },
      block: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md', block: false },
  }
);

export function Button({ variant, size, block, icon: Icon, className, children, ...props }) {
  const iconSize = size === 'sm' ? 13 : size === 'lg' ? 16 : 15;
  return (
    <button className={cn(buttonVariants({ variant, size, block }), className)} {...props}>
      {Icon && <Icon size={iconSize} strokeWidth={1.7} />}
      {children}
    </button>
  );
}

export default Button;
